import React from 'react';
import { usePermissions } from '../contexts/PermissionsContext';

const calculateIsDuringEmbargo = (
  year: string | undefined,
  isAfterEmbargoDate: Record<string, boolean | Date> | undefined,
) => {
  // if selected year = false for isAfterEmbargoDate,
  // return true to indicate it is duringEmbargo
  if (year && isAfterEmbargoDate) return !isAfterEmbargoDate[year];

  return false;
};

const RequirePermission: React.FC<{
  useNewPermissions?: boolean;
  resource?: string | string[];
  action?: string | string[];
  newAction?: string;
  year?: string;
  sdgId?: string;
  availableImpactYears?: number[];
  isAfterEmbargoDate?: Record<string, boolean | Date>;
  institutionId?: string;
  requireAny?: boolean;
  DeniedComponent?: React.FC<{
    resource?: string;
    action: string | string[];
  }>;
}> = ({
  children,
  useNewPermissions,
  institutionId,
  year,
  sdgId,
  availableImpactYears,
  isAfterEmbargoDate,
  newAction,
  resource,
  action,
  requireAny = false,
  DeniedComponent,
}) => {
  const { hasResourcePermission, hasResourcePermissionNew } = usePermissions();
  const isDuringEmbargo = calculateIsDuringEmbargo(year, isAfterEmbargoDate);
  const allow = useNewPermissions
    ? hasResourcePermissionNew({
        action: newAction || '',
        year: Number(year),
        institutionId: institutionId || '',
        sdgId: Number(sdgId),
        availableImpactYears,
        isDuringEmbargo,
      })
    : hasResourcePermission(resource || '', action || '', requireAny);

  if (!allow) {
    if (DeniedComponent) {
      return (
        <DeniedComponent
          resource={Array.isArray(resource) ? resource[0] : resource}
          action={(useNewPermissions ? newAction : action) || ''}
        />
      );
    }
    return null;
  }
  return <>{children}</>;
};

export default RequirePermission;
